import React from 'react'

const AuthDevicesContext = React.createContext();
AuthDevicesContext.displayName = "AuthDevicesContext";

export default AuthDevicesContext;